import Cookies from "js-cookie";

import { authConfig } from "@/config/auth";

// 1. 导入 MSAL
import { PublicClientApplication } from '@azure/msal-browser';

const TokenKey = "User-Token";
const IdToken = "idToken";

export function getToken() { 
  //return Cookies.get(TokenKey);
  return sessionStorage.getItem(IdToken); //測試用，後續要找更安全方法處理OID取得問題
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {  
  return Cookies.remove(TokenKey);  
}

export class AuthService {
  // 跳转到登录页面
  login() {
    const authParams = {
      client_id: authConfig.client_id,
      redirect_uri: authConfig.redirect_uri,
      response_type: authConfig.response_type,
      scope: authConfig.scope,
      response_mode: authConfig.response_mode,
      state: this.generateRandomString(), // 防 CSRF
      nonce: this.generateRandomString(),
    };
    const policy = "p=b2c_1_diastudio_login&";
    const queryString = Object.keys(authParams)
      .map((key) => `${key}=${authParams[key]}`)
      .join("&");

    const path = `${authConfig.authority}/oauth2/v2.0/authorize?${policy}${queryString}`;
    // 存储state用于验证回调
    localStorage.setItem("oauth_state", authParams.state);

    localStorage.setItem("oauth_nonce", authParams.nonce);
    window.location.href = path;
  }

  // 处理回调，解析 token 获取 OID
  handleCallback() {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);

    const idToken = params.get("id_token");
    if (idToken) {
      const userData = this.parseJwt(idToken);
      return {
        oid: userData.oid, // 这是你要的 OID
        email: userData.emails ? userData.emails[0] : null,
        name: userData.name,
      };
    }
    return null;
  }

  // 解析 JWT token
  parseJwt(token) {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error("Failed to parse JWT:", error);
      return null;
    }
  }

  generateRandomString() {
    return Math.random().toString(36).substring(2, 15);
  }

  //登出
  logout() {
    const authParams = {
      
      post_logout_redirect_uri: authConfig.post_logout_redirect_uri,
      
    };
    const policy = "p=b2c_1_diastudio_register&";
    const queryString = Object.keys(authParams)
      .map((key) => `${key}=${authParams[key]}`)
      .join("&");

    const path = `${authConfig.authority}/oauth2/v2.0/logout?${policy}${queryString}&ui_locales=zh-Hans&x-client-SKU=ID_NET461&x-client-ver=5.3.0.0`;
    // 存储state用于验证回调  
    window.location.href = path;

    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("idToken");
    sessionStorage.removeItem("firstName");
    sessionStorage.removeItem("lastName");
  }


}

export class MSALService{
  async login() {
    try {
      // 2. 创建 MSAL 实例
      const msalInstance = new PublicClientApplication(authConfig.msal);
      await msalInstance.initialize();
      
      // 3. 登录请求配置
      const loginRequest = {
        scopes: ["openid", "profile", "email", "https://diaidentityservice.azurewebsites.net/.default"],
        redirectUri: authConfig.msal.auth.redirectUri
      };
      
      // 4. 执行登录
      const loginResponse = await msalInstance.loginPopup(loginRequest);
      
      // 5. 获取账户信息
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        const account = accounts[0];
        localStorage.setItem("user_account", JSON.stringify(account));
        return account;
      }
      
    } catch (error) {
      console.error("登录失败:", error);
      throw error;
    }
  }

  async logout() {
    try {
      // 1. 获取当前 MSAL 实例
      const msalInstance = new PublicClientApplication(authConfig.msal);
      
      // 2. 获取当前账户
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        const logoutRequest = {
          account: accounts[0],
          postLogoutRedirectUri: authConfig.msal.auth.postLogoutRedirectUri
        };
        
        // 3. 执行登出
        await msalInstance.logoutPopup(logoutRequest);
      } else {
        // 如果没有账户信息，使用传统的重定向登出
        const logoutParams = {
          post_logout_redirect_uri: authConfig.post_logout_redirect_uri
        };
        
        const queryString = Object.keys(logoutParams)
          .map(key => `${key}=${logoutParams[key]}`)
          .join("&");
        
        const path = `${authConfig.authority}/oauth2/v2.0/logout?${queryString}`;
        window.location.href = path;
      }
      
      // 4. 清除本地存储
      localStorage.removeItem("user_account");
      localStorage.removeItem("oauth_state");
      localStorage.removeItem("oauth_nonce");
      
    } catch (error) {
      console.error("登出失败:", error);
    }
  }
}
